<template>
  <div>
    <AppLayoutHeader :hide-hamburger-button="true" />
    <div class="form-container">
      <Stage :stage="3" />
      <div class="pa-3">
        <h2 class="--prm text-center">{{ $t('text.stage.complete') }}</h2>
        <p class="mt-6">
          Vacation Styleの入会手続きが完了しました。<br>
          通知のメールをご登録のメールアドレスにお送りしました。<br>
          なおVacation Styleは専用の会員ページにてご予約を承っております。通知のメールをご確認頂き再度ログインをお願いいたします。
        </p>
        <v-btn to="/login" class="mt-4 mb-12" rounded block color="primary" x-large>{{ $t('common.login') }}</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import AppLayoutHeader from '@/layout/AppLayout/components/AppLayoutHeader'
import Stage from './Stage.vue'

export default {
  components: { AppLayoutHeader, Stage }
}
</script>
